import React, { useState } from "react";
import PortalTab from "./PortalTab";

/**
 * Website widget: copy-paste iframe snippet + live preview.
 */
export default function WidgetTab({
    shop,
    plans,
    resourceTypes,
    resources,
    bookings,
    onBook,
    onReschedule,
    onCancel
}) {
    const [copied, setCopied] = useState(false);

    const base =
        typeof window !== "undefined"
            ? window.location.origin
            : "https://bookings.example.com";

    const iframe = `<div id="widget-booking"></div><script src="${base}/widget/booking.js" data-client-id="${shop.apiKey}"></script>`;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(iframe);
        } catch {
            const ta = document.createElement("textarea");
            ta.value = iframe;
            document.body.appendChild(ta);
            ta.select();

            try {
                document.execCommand("copy");
            } catch {
                // Ignore clipboard failure
            }

            ta.remove();
        }

        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="space-y-4">
            {/* Embed code */}
            <div className="hk-card">
                <h5 className="hk-card-title">
                    Embed your booking widget
                </h5>

                <p className="text-sm text-[#64748b] mb-3">
                    Copy and paste this code into your website where you want
                    the booking form to appear.
                </p>

                <textarea
                    className="hk-input hk-mono"
                    rows="4"
                    readOnly
                    value={iframe}
                    style={{ fontSize: "0.72rem" }}
                />

                <button
                    className="hk-btn hk-btn-dark hk-btn-sm mt-2"
                    onClick={copy}
                >
                    {copied ? "✓ Copied" : "Copy embed code"}
                </button>
            </div>

            {/* Live preview */}
            <div>
                <h5 className="hk-card-title px-1">
                    Live preview
                </h5>

                <p className="text-sm text-[#64748b] px-1 mb-3">
                    This is what customers will see on your website.
                </p>

                <PortalTab
                    shop={shop}
                    plans={plans}
                    resourceTypes={resourceTypes}
                    resources={resources}
                    bookings={bookings}
                    onBook={onBook}
                    onReschedule={onReschedule}
                    onCancel={onCancel}
                />
            </div>
        </div>
    );
}